import request from '@/config/axios'

export interface MaintenanceVO {
  id: string | number
  shopId: string | number
  roomId: string | number
  roomNo?: string
  orderNo: string
  faultType: string
  faultDesc?: string
  priority: number // 0低/1中/2高/3紧急
  status: number // 0待派单/1已派单/2维修中/3待验收/4已完成/5已取消
  assigneeId?: string | number
  assigneeName?: string
  assignTime?: string
  startTime?: string
  completeTime?: string
  cost?: number
  verifyUser?: string
  verifyTime?: string
  verifyRemark?: string
  remark?: string
  createTime?: string
}

export interface AssignDTO {
  id: string | number
  assigneeId: string | number
  assigneeName: string
}

export interface CompleteDTO {
  id: string | number
  cost: number
}

export interface VerifyDTO {
  id: string | number
  verifyUser: string
  verifyRemark?: string
}

// 维修工单分页查询
export const getMaintenancePage = (params: any) => {
  return request.get({ url: '/hotel/maintenance/page', params })
}

// 新增报修
export const createMaintenance = (data: MaintenanceVO) => {
  return request.post({ url: '/hotel/maintenance/create', data })
}

export const deleteMaintenance = (id: string | number) => {
  return request.delete({ url: '/hotel/maintenance/delete?id=' + id })
}

// 派单
export const assign = (data: AssignDTO) => {
  return request.put({ url: '/hotel/maintenance/assign', data })
}

// 开始维修
export const start = (id: string | number) => {
  return request.put({ url: '/hotel/maintenance/start', data: { id } })
}

// 完成维修
export const complete = (data: CompleteDTO) => {
  return request.put({ url: '/hotel/maintenance/complete', data })
}

// 验收维修
export const verify = (data: VerifyDTO) => {
  return request.put({ url: '/hotel/maintenance/verify', data })
}
